/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class V1ExclusionAddressesAttached {
    'subscriptionId'?: string;
    'action'?: string;
    'fileId'?: string;
    'fileName'?: string;
    'recordCount'?: number;
    'timestamp'?: Date;
    'userId'?: string;
    'userName'?: string;
    'pixelId'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "subscriptionId",
            "baseName": "subscription_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "action",
            "baseName": "action",
            "type": "string",
            "format": ""
        },
        {
            "name": "fileId",
            "baseName": "file_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "fileName",
            "baseName": "file_name",
            "type": "string",
            "format": ""
        },
        {
            "name": "recordCount",
            "baseName": "record_count",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "userId",
            "baseName": "user_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "userName",
            "baseName": "user_name",
            "type": "string",
            "format": ""
        },
        {
            "name": "pixelId",
            "baseName": "pixel_id",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1ExclusionAddressesAttached.attributeTypeMap;
    }

    public constructor() {
    }
}

